import { VirtualAgentPresence } from "@/playground/components/DevHome/table/components/VirtualAgentPresence/VirtualAgentPresence";
import { VirtualAgentTag } from "@/playground/components/DevHome/table/components/VirtualAgentTag/VirtualAgentTag";
import { CellTypography } from "../../../pages/conversation_center/components/CellTypography/CellTypography";
import { HeaderSimple } from "../../../pages/conversation_center/components/HeaderSimple/HeaderSimple";
import type {
  RowData,
  UserRowType,
} from "../../../pages/conversation_center/components/Table/Table.decl";
import type { ColumnType } from "../columns.decl";

export const userWithVirtualAgentsConfig: ColumnType = {
  id: "user",
  label: <HeaderSimple label="user" />,
  renderer: (rowData: RowData, value) => {
    const { virtualAgents } = rowData;

    if (!value?.length && !virtualAgents?.length) {
      return null;
    }

    // Old behaviour.
    if (!virtualAgents.length) {
      const [main, ...additionalUsers]: UserRowType[] = value;
      const entries = additionalUsers.map((user) => ({
        id: user.id,
        text: user.fullName,
      }));

      return (
        <CellTypography extraEntries={entries}>{main.fullName}</CellTypography>
      );
    }

    if (virtualAgents.length === 1 && !value.length) {
      const [virtualAgent] = virtualAgents;

      return <VirtualAgentTag name={virtualAgent.name} />;
    }

    if (virtualAgents.length === 1 && value.length && value[0]) {
      const [virtualAgent] = virtualAgents;
      const [main, ...rest]: UserRowType[] = value;

      return (
        <VirtualAgentPresence
          virtualAgentName={virtualAgent.name}
          mainAgentName={main.fullName}
          otherAgentNames={rest?.map((user) => user.fullName)}
        />
      );
    }

    return null;
  },
};
